
<template>
    
        <mars-view class="mark"><mars-view class="model-wrapper"><mars-view class="title">
            {{ info.title }}
            <mars-view class="icon iconfont title-close" @click.native="close('close')"></mars-view></mars-view><mars-view class="content">
            {{ info.content }}
        </mars-view><mars-view class="btn" @click.native="close('confirm')">{{ info.btnText }}</mars-view></mars-view></mars-view>
    
</template>

<script>
export default {
  mounted() {
    document.addEventListener('click', this.hideMenu);
    document.getElementsByClassName('swan-app-navigation-bar')[0].addEventListener('click', this.hideMenu);
  },
  props: {
    info: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {},
  data() {
    return {};
  },
  methods: {
    close(type) {
      this.$emit('closeModel', type);
    }
  }
};
</script>

<style scoped>
.mark {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.model-wrapper {
  width: 3.31rem;
  background: #fff;
  border: 1px solid #fff;
  border-radius: 0.13rem;
  padding-bottom: 0.18rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
}
.model-wrapper .title {
  font-family: PingFangSC-Medium;
  font-size: 0.17rem;
  color: #1f1f1f;
  line-height: 1;
  text-align: center;
  padding-top: 0.18rem;
  position: relative;
}
.model-wrapper .title .title-close {
  width: 0.21rem;
  height: 0.21rem;
  position: absolute;
  top: 0.14rem;
  right: 0.18rem;
  padding: 0.04rem;
  box-sizing: border-box;
}
.model-wrapper .content {
  width: 2.9rem;
  font-family: PingFangSC-Regular;
  font-size: 0.16rem;
  color: #1f1f1f;
  text-align: center;
  line-height: 0.22rem;
  margin: 0.27rem auto 0;
  user-select: text;
}
.model-wrapper .btn {
  width: 2.5rem;
  height: 0.44rem;
  background: #4e6ef2;
  border-radius: 0.22rem;
  font-family: PingFangSC-Medium;
  font-size: 0.16rem;
  color: #fff;
  text-align: center;
  line-height: 0.44rem;
  margin: 0.27rem auto 0;
}

</style>
